/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './removeRule.defs.js'
export { main as default } from './removeRule.defs.js'
